import { injectIntl, IntlShape } from 'react-intl';
import { useMemo, useState } from 'react';
import { get, isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import {
  ActionButton,
  ActionButtonWrapper,
} from 'containers/CourtManagerLegalProceedings/Provision/styled-components';
import { translate } from 'containers/services/translate';
import { RiskContainer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import {
  fillDefaultFieldRcMaterial,
  fillDefaultCorpoFields,
  getRisks,
  getTypes,
  formatMaterialRisk,
  getRegulationNature,
  formatMaterialEncryptedDocument,
  formatDocumentRegulation,
  formatRegulationCorporeal,
  formatProvision,
  setJudgementAmount,
  uploadSheets,
  formatProvisionBody,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import AssociatedRisks from 'containers/CourtManagerLegalProceedings/Provision/Regulation/AssociatedRisks';
import RiskTypes from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RiskTypes';
import RegulationInformation from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationInformation';
import { Listings } from 'containers/AppContainer/typings';
import RiskDialog from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RiskDialog';
import RiskAmount from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RiskAmount';
import RegulationRecap from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/index';
import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { isSubstituteNatureRemainder } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/utils';
import { AssignedLawyer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import ProvisionDialog from 'containers/CourtManagerLegalProceedings/Provision/Regulation/ProvisionDialog';
import { PROCEDURE_STEPS } from 'containers/data-structure';
import { PROVISION_ITEM } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import { ClaimRecapType } from 'typings/claimTypes';

export interface RiskProps {
  intl: IntlShape;
  sagisClaim: any;
  claimRecap: ClaimRecapType;
  setRiskRecap: Function;
  riskRecap: any;
  listings: Listings;
  judgementOnMeritsByVictims: any;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVehicles: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  requestCreateCorpoEncryptedDocument: Function;
  corporealEncryptedDocuments: any;
  setShowSideRecap: Function;
  substituteDocumentNature: any;
  setSubstituteDocumentNature: Function;
  setShowRegulationJudgement: Function;
  requestCreateCorporealRegulation: Function;
  requestCreateMaterialRegulation: Function;
  requestCreateAdditionalWarrentiesRegulation: Function;
  requestMaterialEncryptedDocument: Function;
  materialEncryptedDocuments: any;
  activeStep: number;
  setActiveStep: Function;
  requestGetAssignedLawyers: Function;
  assignedLawyers: AssignedLawyer[];
  requestSagisClaimInfo: Function;
  requestGetDahirAmount: Function;
  requestGetDahirAmountCorpo: Function;
  dahirAmount: any;
  dahirAmountsCorpo: any;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
  uploadedDocument: IUploadedDocument;
  requestValidateProvisionIntervenant: Function;
  createdRegulations: any;
  requestCreateSummarySheetRegulation: Function;
  uploadDocumentRegulation: Function;
  judgementOnMeritsWithCivjvm: any;
  corpoRegulations: any;
  policyInfo: any;
  requestValidateProvision: Function;
  lastSagisClaim: any;
  isBasicManagementRegulation?: boolean;
  judgementNatureProcedureIds: any;
}

export const Risk: React.FC<RiskProps> = ({
  sagisClaim,
  claimRecap,
  listings,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  corporealEncryptedDocuments,
  setShowSideRecap,
  substituteDocumentNature,
  setSubstituteDocumentNature,
  setShowRegulationJudgement,
  materialEncryptedDocuments,
  ...props
}): JSX.Element => {
  const [riskData, setRiskData] = useState<any>({
    victims: [],
    vehicles: [],
    additionalGuarantees: [],
  });
  const [errorSummarySheet, setErrorSummarySheet] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const { rcCorpo, rcMaterial, additionalWarrenties } = useMemo(
    () => getRisks(props.riskRecap),
    [props.riskRecap],
  );
  const createRegulationWithSummarySheet = (
    formattedCorpoRegulation: any,
    provision: any,
    isRegulation: boolean,
  ) => {
    const regulationInfo = {
      victimSettlementDemands: formattedCorpoRegulation,
      provision,
      document: { url: get(props.uploadedDocument, 'response') },
      creator: currentUserStorage?.get().username,
      isRegulation: true,
    };
    !isEmpty(rcCorpo) &&
      props.uploadDocument({
        base64Url,
        regulationInfo,
        successCallBack: successCallBack(isRegulation, rcCorpo),
      });
  };

  const [isStepValidated, setIsStepValidated] = useState({} as any);
  const [isJomValidated, setIsJomValidated] = useState({});

  const [openDialog, setOpenDialog] = useState(false);
  const [riskTypes, setRiskTypes] = useState(getTypes(messages, props) as any);
  const [showValidationButton, setShowValidationButton] = useState(false);
  const [isRegulationValidated, setIsRegulationValidated] = useState({
    [props.activeStep]: { activeStep: false, message: '' },
  });
  const [messageError, setMessageError] = useState<any>({});
  const [corpoEncryptedDocuments, setCorpoEncryptedDocuments] = useState<any>(
    [],
  );
  const [showActionButton, setShowActionButton] = useState(true);

  const substituteNatureRemainder = isSubstituteNatureRemainder(
    get(listings, 'EncryptDocumentNature', []),
    rcCorpo,
  );
  const [encryptedDocumentsOfMinors, setEncryptedDocumentsOfMinors] = useState(
    {},
  );
  const [encryptedDocumentsOfAdults, setEncryptedDocumentsOfAdults] = useState(
    {},
  );
  const [provisionInfo, setProvisionInfo] = useState({
    [PROVISION_ITEM.VICTIMS]: {
      provisionAmount: '',
      provisionReason: '',
    },
    [PROVISION_ITEM.CONTRIBUTORS]: {},
  });

  const [base64Url, setBase64Url] = useState(null);

  const handleNext = (activeStep: number) => {
    switch (activeStep) {
      case 0: {
        const types = getTypes(messages, props);
        const existingTypes = types.filter(
          (t: any) => !isEmpty(riskData[t.title]),
        );
        setRiskTypes(existingTypes);
        setIsRegulationValidated({
          ...isRegulationValidated,
          [activeStep]: { activeStep: false, message: '' },
        });
        setIsStepValidated({ ...isStepValidated, [activeStep]: false });

        return props.setActiveStep(props.activeStep + 1);
      }
      case 1: {
        setIsRegulationValidated({
          ...isRegulationValidated,
          [activeStep]: { activeStep: false, message: '' },
        });
        setIsStepValidated({ ...isStepValidated, [activeStep]: false });
        return props.setActiveStep(activeStep + 1);
      }
      case 2: {
        const errorByRisk = Object.values({ ...messageError }).filter(
          item => !isEmpty(item),
        );

        if (!isEmpty(errorByRisk)) {
          return setIsStepValidated({ ...isStepValidated, [activeStep]: true });
        }
        getRegulationNature(
          props.riskRecap,
          props.setRiskRecap,
          get(listings, 'EncryptDocumentNature', []),
          sagisClaim,
          get(listings, 'PaymentStatus', []),
        );
        setJudgementAmount(
          props.riskRecap,
          props.setRiskRecap,
          props.judgementOnMeritsByVictims,
          props.judgementOnMeritsWithCivjvm,
          props.judgementOnMeritsByVehicles,
          get(sagisClaim, 'regulations', []),
          get(listings, 'PaymentStatus', []),
          props.isBasicManagementRegulation,
        );
        setOpenDialog(!isEmpty(rcCorpo) || !isEmpty(rcMaterial));
        return (
          isEmpty(rcCorpo) &&
          isEmpty(rcMaterial) &&
          props.setActiveStep(props.activeStep + 1)
        );
      }
      case 3: {
        !isEmpty(rcCorpo) &&
          fillDefaultCorpoFields(props.riskRecap, props.setRiskRecap, listings);

        !isEmpty(rcMaterial) &&
          fillDefaultFieldRcMaterial(
            listings,
            props.riskRecap,
            props.setRiskRecap,
            rcMaterial,
          );
        !isEmpty(additionalWarrenties) &&
          fillDefaultFieldRcMaterial(
            listings,
            props.riskRecap,
            props.setRiskRecap,
            additionalWarrenties,
          );
        handleValidate(false);
      }
    }
  };
  const failCallBack = () => {
    setShowValidationButton(false);
    setShowActionButton(false);
  };
  const handleValidate = (isRegulation: boolean) => {
    const formattedMaterialRegulation = formatMaterialRisk(
      rcMaterial,
      sagisClaim,
      listings,
      materialEncryptedDocuments,
    );
    const formattedAWRegulation = formatMaterialRisk(
      additionalWarrenties,
      sagisClaim,
      listings,
      materialEncryptedDocuments,
    );

    if (!isRegulation) {
      if (!isEmpty(rcCorpo)) {
        const formattedCorpoDocument = formatDocumentRegulation(
          corporealEncryptedDocuments,
          rcCorpo,
          sagisClaim,
          substituteNatureRemainder,
          get(listings, 'PaymentStatus', []),
          props.isBasicManagementRegulation,
        );

        !isEmpty(formattedCorpoDocument) &&
          props.requestCreateCorpoEncryptedDocument(
            [formattedCorpoDocument],
            successCallBack(isRegulation, rcCorpo),
          );
        setCorpoEncryptedDocuments(formattedCorpoDocument);
      }

      if (!isEmpty(rcMaterial) || !isEmpty(additionalWarrenties)) {
        const materialEncryptedDocumentPayload = formatMaterialEncryptedDocument(
          rcMaterial,
          sagisClaim,
        );

        const additionalWarrentiesEncryptedDocumentPayload = formatMaterialEncryptedDocument(
          additionalWarrenties,
          sagisClaim,
        );
        props.requestMaterialEncryptedDocument(
          [
            ...materialEncryptedDocumentPayload,
            ...additionalWarrentiesEncryptedDocumentPayload,
          ],
          successCallBack(isRegulation, rcMaterial),
        );
      }
    } else {
      const formattedCorpoRegulation = formatRegulationCorporeal(
        listings,
        corporealEncryptedDocuments,
        rcCorpo,
        sagisClaim,
        substituteNatureRemainder,
        encryptedDocumentsOfMinors,
        encryptedDocumentsOfAdults,
        props.corpoRegulations,
        get(listings, 'PaymentStatus', []),
        props.isBasicManagementRegulation,
      );
      const provision = formatProvision(
        corporealEncryptedDocuments,
        sagisClaim,
        get(rcCorpo, 'riskID'),
      );

      !featureService.hasFeature(FEATURES.REGULATION_V2)
        ? createRegulationWithSummarySheet(
            formattedCorpoRegulation,
            provision,
            isRegulation,
          )
        : !isEmpty(rcCorpo) && featureService.hasFeature(FEATURES.REGULATION_V2)
        ? errorSummarySheet
          ? toast.error(translate(messages.failedSummarySheetToast, props))
          : props.requestCreateCorporealRegulation(
              {
                victimSettlementDemands: formattedCorpoRegulation,
                provision,
                creator: currentUserStorage?.get().username,
                isWorkflowEnabled: featureService.hasFeature(
                  FEATURES.REGULATION_WORKFLOW_VALIDATION,
                ),
                isTrackingActive: featureService.hasFeature(
                  FEATURES.TRACKING_ACTIONS_USER,
                ),
                claimNumber: get(claimRecap, 'claim.claimNumber'),
                claimId: get(claimRecap, 'claim.id'),
              },
              successCallBack(isRegulation, rcCorpo),
              failCallBack,
            )
        : props.resetUploadDocumentStore();

      !isEmpty(additionalWarrenties) &&
        props.requestCreateAdditionalWarrentiesRegulation(
          get(sagisClaim, 'code', ''),
          formattedAWRegulation,
          successCallBack(true, additionalWarrenties),
        );
      !isEmpty(rcMaterial) &&
        props.requestCreateMaterialRegulation(
          get(sagisClaim, 'code', ''),
          formattedMaterialRegulation,
          successCallBack(true, rcMaterial),
        );
    }
  };

  const successCallBack = (isRegulation: boolean, risk: any) => () => {
    if (!isRegulation) {
      setShowSideRecap(false);
      props.activeStep !== 4 && props.setActiveStep(props.activeStep + 1);
      setShowValidationButton(true);
    } else if (isRegulation) {
      setShowValidationButton(false);
      setShowActionButton(false);
      switch (risk.riskName) {
        case RISK_NAME.CORPOREAL:
          toast.success(translate(messages.successCorpoToastTitle, props));
          props.requestSagisClaimInfo(get(claimRecap, 'claim.claimNumber', ''));
          featureService.hasFeature(FEATURES.REGULATION_V2)
            ? setShowDialog(true)
            : props.resetUploadDocumentStore();
          break;
        case RISK_NAME.MATERIEL:
          return toast.success(
            translate(messages.successMaterialToastTitle, props),
          );
        case RISK_NAME.GARANTIES_ANNEXES:
          return toast.success(
            translate(messages.successAdditionalWarrentiesToastTitle, props),
          );
      }
    }
  };

  const handleBack = (activeStep: number) => {
    switch (activeStep) {
      case 0: {
        props.setRiskRecap([]);
        setMessageError({});
        return setRiskData([]);
      }
      case 1: {
        setIsStepValidated({ ...isStepValidated, [activeStep]: false });

        return props.setActiveStep(activeStep - 1);
      }
      case 2: {
        setIsStepValidated({ ...isStepValidated, [activeStep]: false });
        return props.setActiveStep(activeStep - 1);
      }
      case 3: {
        setShowRegulationJudgement(false);
        setIsStepValidated({ ...isStepValidated, [activeStep]: false });
        return props.setActiveStep(activeStep - 1);
      }
      case 4: {
        setShowSideRecap(true);
        setShowValidationButton(false);
        return props.setActiveStep(activeStep - 1);
      }
    }
  };
  const Steps = () => {
    switch (props.activeStep) {
      case 0: {
        return (
          <AssociatedRisks
            sagisClaim={sagisClaim}
            claimRecap={claimRecap}
            setRiskRecap={props.setRiskRecap}
            riskRecap={props.riskRecap}
            riskData={riskData}
            setRiskData={setRiskData}
            riskTypes={riskTypes}
            setRiskTypes={setRiskTypes}
          />
        );
      }
      case 1:
        return (
          <RiskTypes
            sagisClaim={sagisClaim}
            claimRecap={claimRecap}
            setRiskRecap={props.setRiskRecap}
            riskRecap={props.riskRecap}
            riskData={riskData}
            setRiskData={setRiskData}
            riskTypes={riskTypes}
            setRiskTypes={setRiskTypes}
          />
        );
      case 2:
        return (
          <main>
            <RegulationInformation
              sagisClaim={sagisClaim}
              claimRecap={claimRecap}
              setRiskRecap={props.setRiskRecap}
              riskRecap={props.riskRecap}
              listings={listings}
              requestGetJudgementOnMeritsByVictims={
                requestGetJudgementOnMeritsByVictims
              }
              judgementOnMeritsByVictims={props.judgementOnMeritsByVictims}
              judgementOnMeritsByVehicles={props.judgementOnMeritsByVehicles}
              requestGetJudgementOnMeritsByVehicles={
                requestGetJudgementOnMeritsByVehicles
              }
              activeStep={props.activeStep}
              isRegulationValidated={isRegulationValidated}
              setIsRegulationValidated={setIsRegulationValidated}
              riskData={riskData}
              isStepValidated={isStepValidated}
              setIsStepValidated={setIsStepValidated}
              setMessageError={setMessageError}
              messageError={messageError}
              substituteDocumentNature={substituteDocumentNature}
              setSubstituteDocumentNature={setSubstituteDocumentNature}
              isJomValidated={isJomValidated}
              setIsJomValidated={setIsJomValidated}
              requestGetAssignedLawyers={props.requestGetAssignedLawyers}
              judgementOnMeritsWithCivjvm={props.judgementOnMeritsWithCivjvm}
              isBasicManagementRegulation={props.isBasicManagementRegulation}
              judgementNatureProcedureIds={props.judgementNatureProcedureIds}
            />
            {(!isEmpty(rcMaterial) || !isEmpty(rcCorpo)) && (
              <RiskDialog
                judgementOnMeritsByVictims={props.judgementOnMeritsByVictims}
                judgementOnMeritsByVehicles={props.judgementOnMeritsByVehicles}
                activeStep={props.activeStep}
                setActiveStep={props.setActiveStep}
                riskRecap={props.riskRecap}
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                setShowRegulationJudgement={setShowRegulationJudgement}
                isBasicManagementRegulation={props.isBasicManagementRegulation}
              />
            )}
          </main>
        );
      case 3:
        return (
          <RiskAmount
            judgementOnMeritsByVictims={props.judgementOnMeritsByVictims}
            judgementOnMeritsByVehicles={props.judgementOnMeritsByVehicles}
            activeStep={props.activeStep}
            setActiveStep={props.setActiveStep}
            riskRecap={props.riskRecap}
            setRiskRecap={props.setRiskRecap}
            listings={listings}
            rcMaterial={rcMaterial}
            rcCorporeal={rcCorpo}
            additionalWarrenties={additionalWarrenties}
            isStepValidated={isStepValidated}
            setIsStepValidated={setIsStepValidated}
            sagisClaim={sagisClaim}
            requestGetDahirAmount={props.requestGetDahirAmount}
            requestGetDahirAmountCorpo={props.requestGetDahirAmountCorpo}
            dahirAmountsCorpo={props.dahirAmountsCorpo}
            dahirAmount={props.dahirAmount}
            claimId={get(claimRecap, 'claim.id')}
            isBasicManagementRegulation={props.isBasicManagementRegulation}
            corpoRegulations={props.corpoRegulations}
          />
        );
      case 4:
        return (
          <RegulationRecap
            activeStep={props.activeStep}
            setActiveStep={props.setActiveStep}
            riskRecap={props.riskRecap}
            setRiskRecap={props.setRiskRecap}
            listings={listings}
            rcCorporeal={rcCorpo}
            rcMaterial={rcMaterial}
            additionalWarrenties={additionalWarrenties}
            corpoEncryptedDocuments={corpoEncryptedDocuments}
            substituteDocumentNature={substituteDocumentNature}
            corpoEncryptedDocumentsResult={corporealEncryptedDocuments}
            materialEncryptedDocuments={materialEncryptedDocuments}
            lossDate={get(sagisClaim, 'lossDate', '')}
            sagisClaim={sagisClaim}
            showValidationButton={showValidationButton}
            claimRecap={claimRecap}
            judgementOnMeritsByVictims={props.judgementOnMeritsByVictims}
            encryptedDocumentsOfMinors={encryptedDocumentsOfMinors}
            setEncryptedDocumentsOfMinors={setEncryptedDocumentsOfMinors}
            encryptedDocumentsOfAdults={encryptedDocumentsOfAdults}
            setEncryptedDocumentsOfAdults={setEncryptedDocumentsOfAdults}
            assignedLawyers={props.assignedLawyers}
            setBase64Url={setBase64Url}
            base64Url={base64Url}
            provisionInfo={provisionInfo}
            setProvisionInfo={setProvisionInfo}
            hasJom={props.judgementOnMeritsByVictims.some(
              (item: any) => item?.step === PROCEDURE_STEPS.JUDGEMENT_ON_MERITS,
            )}
            corpoRegulations={props.corpoRegulations}
            policyInfo={props.policyInfo}
            lastSagisClaim={props.lastSagisClaim}
            showDialog={showDialog}
            setErrorSummarySheet={setErrorSummarySheet}
            isBasicManagementRegulation={props.isBasicManagementRegulation}
          />
        );
    }
  };
  const handleValidateDialog = () => {
    const formattedProvisionBody = formatProvisionBody(
      get(claimRecap, 'claim.claimNumber', ''),
      provisionInfo,
      sagisClaim,
      rcCorpo,
      get(claimRecap, 'claim.id', ''),
    );
    props.requestValidateProvision &&
      props.requestValidateProvision(
        formattedProvisionBody,
        successCallBackSummarySheet(true),
      );
    uploadSheets(
      base64Url,
      props.uploadDocumentRegulation,
      props.createdRegulations,
      successCallBackSummarySheet,
      successCallBackRecipientSheet,
    );
    setShowDialog(false);
  };

  const successCallBackSummarySheet = (withProvision: boolean) => () => {
    withProvision
      ? toast.success(translate(messages.updateProvisionSuccessToast, props))
      : toast.success(translate(messages.summarySheetGenerationToaster, props));
    return setShowDialog(false);
  };

  const successCallBackRecipientSheet = (isCdra: boolean) => () => {
    isCdra
      ? toast.success(translate(messages.cdraSheetGenerationToast, props))
      : toast.success(translate(messages.cnraSheetGenerationToast, props));
  };
  const handleClose = (event: any, reason: any) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      uploadSheets(
        base64Url,
        props.uploadDocumentRegulation,
        props.createdRegulations,
        successCallBackSummarySheet,
        successCallBackRecipientSheet,
      );
      setShowDialog(false);
    }
  };

  return (
    <RiskContainer>
      {Steps()}
      <div className="action-button">
        {showActionButton && (
          <ActionButtonWrapper>
            <ActionButton
              className="nav"
              onClick={() => {
                handleBack(props.activeStep);
              }}
              data-testid={translate(messages.cancel, props)}
            >
              {translate(messages.cancel, props)}
            </ActionButton>
            {!showValidationButton && (
              <ActionButton
                data-testid={translate(messages.next, props)}
                id={translate(messages.next, props)}
                onClick={() => handleNext(props.activeStep)}
                disabled={
                  get(
                    isRegulationValidated[props.activeStep],
                    'activeStep',
                    false,
                  ) || isStepValidated[props.activeStep]
                }
                className="nav"
              >
                {translate(messages.next, props)}
              </ActionButton>
            )}
          </ActionButtonWrapper>
        )}
        {showValidationButton && (
          <ActionButton
            data-testid={'validate-button'}
            onClick={() => handleValidate(true)}
            className="validate"
          >
            {translate(messages.validationButton, props)}
          </ActionButton>
        )}
        {showDialog && (
          <ProvisionDialog
            open={showDialog}
            setProvisionInfo={setProvisionInfo}
            provisionInfo={provisionInfo}
            handleValidate={handleValidateDialog}
            handleClose={handleClose}
            title={translate(messages.updateProvisionTitle, props)}
            sagisClaim={props.lastSagisClaim}
            listings={listings}
            rcCorpo={rcCorpo}
          />
        )}
      </div>
    </RiskContainer>
  );
};

export default injectIntl(Risk);
